module.exports = __webpack_public_path__ + "static/media/notecards.480d5056.PNG";